import React from "react";
import AestheticHero from "../Component/AestheticHero";
import LuxuryFeatures from "../Component/LuxuryFeatures";
import LuxuryDestinations from "../Component/LuxuryDestinations";
import MemberShipBenifit from "../Component/MemberShipBenifit";
import LuxuryTestimonials from "../Component/LuxuryTestimonials";
import HotelSlider from "../Component/HotelSlider";
import TravelPartner from "../Component/TravelPartner";

const Home = () => {
  return (
    <div className="luxury-home">
      <AestheticHero />
      <LuxuryFeatures />
      <LuxuryDestinations />
      <MemberShipBenifit />
      <HotelSlider />
      <TravelPartner />
    </div>
  );
};

export default Home;
